import React from 'react';
import cname from '../../style.module.scss';
import {Info1} from '../../SpectrophotometerImages';
import {PARTS_ACCORDIAN} from '../../Spectrophotometer.utils';
import {Accordian} from '@learningblocks/storybook-components';

export function ContentParts() {
  const [accordian, updateAccordian] = React.useState(PARTS_ACCORDIAN);

  const onSelectTab = (tabId) => {
    const selectTab = (tab) => {
      if (tab.id === tabId) return {...tab, open: true};
      else return {...tab, open: false};
    };
    updateAccordian((acc) => acc.map(selectTab));
  };

  const OpenImage = React.useMemo(() => {
    let open = accordian.find((a) => a.open);
    if (open) {
      return open.Image;
    } else {
      return Info1;
    }
  }, [accordian]);

  return (
    <div className={cname.content_parts}>
      <div className={cname.content_parts_left}>
        <OpenImage />
      </div>
      <div className={cname.content_parts_right}>
        <Accordian allTabs={accordian} onSelectTab={onSelectTab} />
      </div>
    </div>
  );
}
